export const REACT_APP_API_GRAPHQL_URL = 'a';

export const MAPBOX_KEY = 'a'
